import React from 'react';
import { palette, radii, shadows, transitions } from '../../theme';

export function Card({ className = '', noPadding = false, ...props }: React.HTMLAttributes<HTMLDivElement> & { noPadding?: boolean }) {
  return (
    <div
      className={`${palette.surface} ${palette.border} ${radii.md} ${shadows.base} ${transitions.default} ${noPadding ? '' : 'px-5 py-4'} ${className}`}
      {...props}
    />
  );
}
